import dayjs from 'dayjs'

export const convertUTCToLocal = (date = '') => {
    if (!date) return ''
    return dayjs.utc(date).local()
}

export const isValidArray = (data) => {
    return data && Array.isArray(data) && data.length > 0
}

export const isValidObject = (data) => {
    return (
        typeof data === 'object' &&
        data !== null &&
        Object.keys(data).length !== 0
    )
}

/** Truncates a string when longer than `maxLength`, appending `...`. */
export const truncateWithEllipsis = (text, maxLength) => {
    if (text == null || text === '') return ''
    const s = String(text)
    const limit = Number(maxLength)
    if (!Number.isFinite(limit) || limit < 0) return s
    if (s.length <= limit) return s
    return `${s.slice(0, limit)}...`
}
